import { getMobileScaledFont, overrideFontSize } from '@wix/thunderbolt-becky-root'
import { getFontValue } from '../../core/mappers/ScaledFont/ScaledFont.mapper'
import type { TimePickerCSSVars, TimePickerDefinition } from '@wix/thunderbolt-components-native'
import { withCompInfo } from '@wix/editor-elements-integrations'

export const css = withCompInfo<TimePickerCSSVars, TimePickerDefinition>()(
	// @ts-ignore - remove once siteFonts is added to CompInfo
	['compProps', 'isMobileView', 'styleProperties', 'compLayout', 'compDesign', 'siteFonts'],
	// @ts-ignore - remove once siteFonts is added to CompInfo
	({ compProps, isMobileView, styleProperties, compLayout, siteFonts }) => {
		const labelFontWithOverride = getFontValue({
			themeFontMap: siteFonts,
			fontParam: styleProperties.fntlbl,
			isMobileView,
			callback: (fontValue: string) => overrideFontSize(fontValue, compProps.labelMobileFontSize!),
		})

		return {
			'--textFont': getFontValue({
				themeFontMap: siteFonts,
				fontParam: styleProperties.textFont,
				isMobileView,
				callback: (fontValue: string) =>
					getMobileScaledFont(fontValue, compLayout.scale!, 0, compProps.inputMobileFontSize),
			}),
			'--fntlbl': labelFontWithOverride,
		}
	}
)
